import { memo, useRef, useState } from 'react'
import { TextField } from '@mui/material'
import { getFieldId } from '../utils/utils'
import FieldHistory from '../../../components/DataEntry/FieldHistory'

const BigTextField = ({
  id,
  value,
  label = null,
  placeholder = null,
  onChange,
  className = '',
  helperText = null,
  disabled = false,
  style = {},
  autoFocus = false,
  allValues,
  field,
  processId,
  inputSx = {},
  ...props
}) => {
  const [clicked, setClicked] = useState(false)
  const inputRef = useRef(null)

  const handleClick = () => {
    if (!clicked) {
      setClicked(true)
      setTimeout(() => {
        inputRef.current?.focus()
      }, 100)
    }
  }

  const textArea = (
    <TextField
      onClick={handleClick}
      inputRef={inputRef}
      id={getFieldId(id)}
      name={getFieldId(id)}
      value={value}
      fullWidth
      style={style}
      className={className}
      autoFocus={autoFocus}
      multiline
      size="small"
      variant="outlined"
      color="primary"
      label={label}
      placeholder={placeholder}
      maxRows={2}
      onChange={onChange}
      error={helperText != null}
      // helperText={helperText}
      {...props}
      disabled={disabled}
      sx={inputSx}
    />
  )

  if (!field || field.is_subfield) {
    return textArea
  } else {
    return (
      <FieldHistory
        fieldId={field?.id}
        field={field}
        allValues={allValues}
        helperText={helperText}
        processId={processId}
      >
        <div>{textArea}</div>
      </FieldHistory>
    )
  }
}
export default memo(
  BigTextField,
  (prevProps, nextProps) =>
    prevProps.value === nextProps.value && prevProps.helperText === nextProps.helperText,
)
